var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61294 5.84948L5.72386 5.72386C6.20452 5.24322 6.96082 5.20625 7.48388 5.61294L7.60949 5.72386L16 14.1133L24.3905 5.72386C24.9112 5.20317 25.7555 5.20317 26.2761 5.72386C26.7968 6.24457 26.7968 7.08878 26.2761 7.60949L17.8867 16L26.2761 24.3905C26.7568 24.8712 26.7937 25.6275 26.3871 26.1505L26.2761 26.2761C25.7955 26.7568 25.0392 26.7937 24.5161 26.3871L24.3905 26.2761L16 17.8867L7.60949 26.2761C7.08878 26.7968 6.24457 26.7968 5.72386 26.2761C5.20317 25.7555 5.20317 24.9112 5.72386 24.3905L14.1133 16L5.72386 7.60949C5.24322 7.12884 5.20625 6.37253 5.61294 5.84948Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.e3024371366fe78ab8e235f3e4975ae4.svg";
export { ForwardRef as ReactComponent };